import { State } from '../../types/graphql'

export const StateAbbreviationMap: Record<State, string> = {
  Alabama: 'AL',
  Alaska: 'AK',
  Arizona: 'AZ',
  Arkansas: 'AR',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  Delaware: 'DE',
  DistrictOfColumbia: 'DC',
  Florida: 'FL',
  Georgia: 'GA',
  Hawaii: 'HI',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Iowa: 'IA',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  Maryland: 'MD',
  Massachusetts: 'MA',
  Michigan: 'MI',
  Minnesota: 'MN',
  Mississippi: 'MS',
  Missouri: 'MO',
  Montana: 'MT',
  NativeSovereignNation: 'NSN',
  Nebraska: 'NE',
  Nevada: 'NV',
  NewHampshire: 'NH',
  NewJersey: 'NJ',
  NewMexico: 'NM',
  NewYork: 'NY',
  NorthCarolina: 'NC',
  NorthDakota: 'ND',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Pennsylvania: 'PA',
  PuertoRico: 'PR',
  RhodeIsland: 'RI',
  SouthCarolina: 'SC',
  SouthDakota: 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  USArmedForcesAmericas: 'AA',
  USArmedForcesEurope: 'AE',
  USArmedForcesPacific: 'AP',
  Utah: 'UT',
  Vermont: 'VT',
  Virginia: 'VA',
  Washington: 'WA',
  WestVirginia: 'WV',
  Wisconsin: 'WI',
  Wyoming: 'WY',
}

// alphabetized by State value, not by key
export const StateAbbreviationToStateNameMap: Record<string, State> = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'DistrictOfColumbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NSN: 'NativeSovereignNation',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'NewHampshire',
  NJ: 'NewJersey',
  NM: 'NewMexico',
  NY: 'NewYork',
  NC: 'NorthCarolina',
  ND: 'NorthDakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  PR: 'PuertoRico',
  RI: 'RhodeIsland',
  SC: 'SouthCarolina',
  SD: 'SouthDakota',
  TN: 'Tennessee',
  TX: 'Texas',
  AA: 'USArmedForcesAmericas',
  AE: 'USArmedForcesEurope',
  AP: 'USArmedForcesPacific',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'WestVirginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
}

export const StateNameMap: Record<State, string> = {
  Alabama: 'Alabama',
  Alaska: 'Alaska',
  Arizona: 'Arizona',
  Arkansas: 'Arkansas',
  California: 'California',
  Colorado: 'Colorado',
  Connecticut: 'Connecticut',
  Delaware: 'Delaware',
  DistrictOfColumbia: 'District of Columbia',
  Florida: 'Florida',
  Georgia: 'Georgia',
  Hawaii: 'Hawaii',
  Idaho: 'Idaho',
  Illinois: 'Illinois',
  Indiana: 'Indiana',
  Iowa: 'Iowa',
  Kansas: 'Kansas',
  Kentucky: 'Kentucky',
  Louisiana: 'Louisiana',
  Maine: 'Maine',
  Maryland: 'Maryland',
  Massachusetts: 'Massachusetts',
  Michigan: 'Michigan',
  Minnesota: 'Minnesota',
  Mississippi: 'Mississippi',
  Missouri: 'Missouri',
  Montana: 'Montana',
  NativeSovereignNation: 'Native Sovereign Nation',
  Nebraska: 'Nebraska',
  Nevada: 'Nevada',
  NewHampshire: 'New Hampshire',
  NewJersey: 'New Jersey',
  NewMexico: 'New Mexico',
  NewYork: 'New York',
  NorthCarolina: 'North Carolina',
  NorthDakota: 'North Dakota',
  Ohio: 'Ohio',
  Oklahoma: 'Oklahoma',
  Oregon: 'Oregon',
  Pennsylvania: 'Pennsylvania',
  PuertoRico: 'Puerto Rico',
  RhodeIsland: 'Rhode Island',
  SouthCarolina: 'South Carolina',
  SouthDakota: 'South Dakota',
  Tennessee: 'Tennessee',
  Texas: 'Texas',
  USArmedForcesAmericas: 'U.S. Armed Forces - AA',
  USArmedForcesEurope: 'U.S. Armed Forces - AE',
  USArmedForcesPacific: 'U.S. Armed Forces - AP',
  Utah: 'Utah',
  Vermont: 'Vermont',
  Virginia: 'Virginia',
  Washington: 'Washington',
  WestVirginia: 'West Virginia',
  Wisconsin: 'Wisconsin',
  Wyoming: 'Wyoming',
}
